export { default } from './ClassPassInfo';

